import _slicedToArray from "/builds/everlywell/apps/www/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import React, { useEffect, useRef, useState } from "react";
import { loadScript } from "../../../shared/loadAsyncScript";
import Input from "../../Input";
import * as S from "./styles";
import { getAddressComponents } from "./utils";
export var inputID = "test-input";
export var fallbackInputID = "test-fallback-input";

function AutocompleteAddress(_ref) {
  var e = _ref.value,
      t = _ref.onChanged,
      a = _ref.apiKey,
      s = _ref.label,
      o = _ref.disabled;

  var _useState = useState(""),
      _useState2 = _slicedToArray(_useState, 2),
      n = _useState2[0],
      l = _useState2[1],
      _useState3 = useState(""),
      _useState4 = _slicedToArray(_useState3, 2),
      r = _useState4[0],
      c = _useState4[1],
      _useState5 = useState(""),
      _useState6 = _slicedToArray(_useState5, 2),
      u = _useState6[0],
      p = _useState6[1],
      _useState7 = useState(""),
      _useState8 = _slicedToArray(_useState7, 2),
      d = _useState8[0],
      i = _useState8[1],
      _useState9 = useState(!1),
      _useState10 = _slicedToArray(_useState9, 2),
      m = _useState10[0],
      f = _useState10[1],
      g = useRef(null),
      I = useRef(null),
      b = useRef(null);

  return useEffect(function () {
    a && loadScript("gmapsAutocompleteAsyncScript", "https://maps.googleapis.com/maps/api/js?key=".concat(a, "&libraries=places"), function () {
      window.google && (b.current = new window.google.maps.places.Autocomplete(g.current, {
        componentRestrictions: {
          country: ["us"]
        },
        fields: ["address_components", "geometry"],
        types: ["address"]
      }), b.current.addListener("place_changed", function () {
        var e = b.current.getPlace().address_components,
            t = getAddressComponents(e);
        l(t.address1), i(t.postcode), p(t.state), c(t.city);
      }), window.gm_authFailure = function () {
        var e;
        f(!0), null === (e = null == I ? void 0 : I.current) || void 0 === e || e.focus();
      });
    });
  }, [a]), useEffect(function () {
    e !== n && l(e || "");
  }, [e]), useEffect(function () {
    n && t(n, {
      address1: n,
      city: r,
      state: u,
      zipcode: d
    });
  }, [n, r, u, d]), useEffect(function () {
    a && !m || t(n);
  }, [n]), React.createElement(React.Fragment, null, s && React.createElement(S.Label, {
    "data-testid": "test-input-label"
  }, s), !a || m ? React.createElement(Input, {
    ref: I,
    id: fallbackInputID,
    name: fallbackInputID,
    autoComplete: "chrome-off",
    value: n,
    onChange: function onChange(e) {
      return l(e.target.value);
    },
    disabled: o
  }) : React.createElement(S.Input, {
    ref: g,
    id: inputID,
    autoComplete: "chrome-off",
    value: n,
    onChange: function onChange(e) {
      return l(e.target.value);
    },
    disabled: o
  }));
}

export default AutocompleteAddress;